import React from "react";
import { Alert } from "@mui/material";
import { LogoCardView } from "./LogoCardView";

interface LogoAlertViewProps {
    severity: "error" | "warning" | "info" | "success";
    message: string;
}

const LogoAlertView: React.FC<LogoAlertViewProps> = ({ severity, message }) => {
    return (
        <LogoCardView>
            <Alert severity={severity}>
                {message}
            </Alert>
        </LogoCardView>
    );
};

export default LogoAlertView;